module.exports = __webpack_public_path__ + "static/img/login_bg.2cf4341.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_bg.jpg
// module id = npKG
// module chunks = 0